export const WHITE_SPACE_REGEX = /\s/g
export const STRING_REGEX = /(\D+)/
